import React, { Component } from 'react';
import about from "assets/img/about.png";
import $ from 'jquery';
import {FaCaretRight} from 'react-icons/fa';


const Faqlist = ({quest, ans}) => {
  return (
      <div className="faqList">
          <div className="quest">
              <div className="iconArrow">
                  <FaCaretRight/>
              </div>
              <div>
                  {quest}
              </div>
          </div>
          <div className="ans" dangerouslySetInnerHTML={{__html: ans}}>
          </div>
      </div>
  )
}
class FaqDirectors extends Component{
	constructor(props) {
        super(props);
        this.state = {
            isHovered: false,
        };
    }

    componentDidMount() {
        $(".faqList > .quest").click(function () {
            $(this).toggleClass("open");
            $(this).next(".ans").stop(true, true).slideToggle("fast");
        });

        $(window).resize(function () {
            setTimeout(function () {
                $("#how_it_works .banner").height($("#how_it_works .banner img").height());
            }, 300);
        });

        // var count = 10;
        $(window).scroll(function () {
            let a = $(this).scrollTop();
            a = a - (a / 5);
            $("#how_it_works .banner img").css({position: 'relative', top: a + 'px'});
        });
    }
 	render(){
  	return(
        <div>
            <section className="faqs">
                <div className="wordpressHeading text-center">FREQUENTLY ASKED QUESTIONS</div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            <Faqlist
                                quest="When will I be able to listen to the Adjudicator’s commentaries?"
                                ans='As soon as they are finished with making their commentary and have uploaded it, you will have immediate access. You will need an Internet connection on your device to do this.'
                            />

                            <Faqlist
                                quest="How do I hear the Adjudicator’s commentary?"
                                ans='You should have received a login code from your festival director. Select the button on the app that says ‘Music Director’. Enter the login code. You will see the judge’s commentaries. Select one of the commentaries, and you will see how to hear the comments on the next screen. Press the red play button and you will be able to listen to them.'
                            />

                            <Faqlist
                                quest="Can I save the commentaries?"
                                ans='Yes, you can do these one of two ways. First, with the app. You will see a ‘download’ icon beside the judge’s commentary. The app will tell you where it is located on your device, so be on the lookout for that.  To save it to your computer, go to musicadjudicator.com. Look at the top right side of the website and select ‘Music Director Login’. Once there, scroll down and you will see where to listen to and download the commentary onto your computer. Please note where it is downloaded so you can find it on your computer later.'
                            />

                            <Faqlist
                                quest="How can I share the commentary with my students?"
                                ans='The easiest way is to give them your login code. They can access it through the app or the website like you can. Or, if you download the audio file commentaries you can email them to your students.'
                            />

                            <Faqlist
                                quest="My festival recorded our performance. Is this available on the app or website?"
                                ans='Sometimes they will provide you with this recording with a physical device like a USB drive. If they added the recording to our system, you could hear it – and download it – from the musicadjudicator.com website. After you login to the website with your login code, you will see a tab that says ‘Festivals Recordings’ beside the tab that says ‘Adjudicator Comments’. If YOU have a recording that you did yourself, you can add this on the website as well. You will see a button that says ‘+ Add Festival Recording’.'
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
  	);
  }
}
export default FaqDirectors;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/FaqDirectors.jsx